module.exports = __webpack_public_path__ + "static/media/first-screen.4fda04e8.svg";